import { i18n } from '@/plugins/i18n'
import {
    TicketStatus
} from '@/constants'
import { invertKeyValues } from '@/common/objects'
import { ticketStatusOption } from '@/common/data'


export const ticketStatusStr = (ticket) => {
    const status = invertKeyValues(TicketStatus)[ticket.status]

    return status ? i18n.t(`ticket.statuses.${status.toLowerCase()}`) : 'undefined'
}

export const ticketStatusBadge = (ticket) => {
    const badges = {
        [TicketStatus.PENDING]: 'warning',
        [TicketStatus.ANSWERD]: 'success',
        [TicketStatus.CLOSED]: 'secondary',
        [TicketStatus.UNDER_INVESTIGATION]: 'affili-eggplant',
        [TicketStatus.CREATED_BY_ADMIN]: 'secondary',
    }

    return badges[ticket.status]
}

export const statusInputClass = (status) => {
    const obj = ticketStatusOption.find(obj => obj.value === status)

    return obj ? obj.style : ''
}